import { render } from "./MostSeenEntitiesChart.vue?vue&type=template&id=54b16146"
import script from "./MostSeenEntitiesChart.vue?vue&type=script&lang=js"
export * from "./MostSeenEntitiesChart.vue?vue&type=script&lang=js"

import "./MostSeenEntitiesChart.vue?vue&type=style&index=0&id=54b16146&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpinner});
